"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_animate_height_1 = __importDefault(require("react-animate-height"));
var useCollapsible_1 = __importDefault(require("../useCollapsible"));
var CollapsibleContent = function (props) {
    var id = props.id, className = props.className, style = props.style, _a = props.htmlElement, htmlElement = _a === void 0 ? 'div' : _a, _b = props.htmlAttributes, htmlAttributes = _b === void 0 ? {} : _b, children = props.children;
    var _c = useCollapsible_1.default(), rootClass = _c.rootClass, transCurve = _c.transCurve, transTime = _c.transTime, isOpen = _c.isOpen;
    var baseClass = rootClass + "__content";
    var mergedClasses = [
        baseClass,
        isOpen && baseClass + "--is-open",
        className,
    ].filter(Boolean).join(' ');
    var Tag = htmlElement;
    return (react_1.default.createElement(Tag, __assign({}, __assign({ id: id, className: mergedClasses, style: style }, htmlAttributes)),
        react_1.default.createElement(react_animate_height_1.default, { height: isOpen ? 'auto' : 0, easing: transCurve || 'linear', duration: transTime || 0 }, children && children)));
};
exports.default = CollapsibleContent;
//# sourceMappingURL=index.js.map